// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dropdown_wrapper__NIO02","trigger":"dropdown_trigger__1Q8jH","list":"dropdown_list___Wl36","item":"dropdown_item__kDVV8"};